import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { AREAS } from "@/data";

export const Areas = () => {
  return (
    <section id="areas" data-testid="areas-section" className="py-20 md:py-28 surface-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#E63946]">Areas Covered</p>
        <h2 className="font-heading mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-steel">
          Proudly serving Buckinghamshire
        </h2>
        <p className="mt-4 text-gray-400 max-w-2xl mx-auto">
          We cover Buckinghamshire and surrounding areas. If your town isn't listed, get in
          touch — we likely cover it too.
        </p>

        <div className="mt-10 flex flex-wrap justify-center gap-3">
          {AREAS.map((a, idx) => (
            <motion.span
              key={a}
              data-testid={`area-tag-${a}`}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: idx * 0.04 }}
              className="inline-flex items-center gap-2 rounded-full card-grey border border-white/10 px-5 py-2.5 text-sm font-semibold text-gray-200 hover:border-[#E63946]/60 hover:text-white transition-colors"
            >
              <MapPin className="w-4 h-4 text-[#E63946]" /> {a}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
};
